<div class="transfer-target-search">
  <div class="tts-filters mb-3">
    <div class="tts-search-group">
      <label for="tts-name" class="form-label tts-filter-label">Search by Borrower Name</label>
      <div class="input-group">
        <input id="tts-name" type="text" class="form-control"
               [formControl]="nameControl"
               placeholder="Borrower Name" />
        <span class="input-group-text tts-search-icon">
          <i class="fas fa-search"></i>
        </span>
      </div>
    </div>
    <div class="tts-search-group">
      <label for="tts-gfcid" class="form-label tts-filter-label">Search by GFCID</label>
      <div class="input-group">
        <input id="tts-gfcid" type="text" class="form-control"
               [formControl]="gfcidControl"
               placeholder="GFCID" />
        <span class="input-group-text tts-search-icon">
          <i class="fas fa-search"></i>
        </span>
      </div>
    </div>
    <button type="button"
            class="btn btn-link tts-clear-btn"
            [disabled]="!nameControl.value && !gfcidControl.value"
            (click)="clearSearch()">
      <i class="fa-solid fa-xmark me-1"></i>Clear Search
    </button>
  </div>

  <div class="tts-results-wrapper" [class.is-invalid]="error">
    <table class="table table-hover tts-table mb-0">
      <thead>
        <tr>
          <th scope="col" class="tts-radio-col"></th>
          <th scope="col">Name</th>
          <th scope="col">Portfolio</th>
          <th scope="col">GFCID</th>
          <th scope="col">SIC</th>
          <th scope="col">Region</th>
          <th scope="col" class="text-end">Date Created</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of searchResults | paginate: { id: pagerId, itemsPerPage: limit, currentPage: page, totalItems: total }"
            (click)="selectRow(row)"
            [class.table-active]="selectedUuid === row.uuid">
          <td class="tts-radio-col">
            <span class="tts-radio"
                  role="radio"
                  [attr.aria-checked]="selectedUuid === row.uuid"
                  [attr.aria-label]="'Select ' + row.name"
                  tabindex="0"
                  (keydown.space)="$event.preventDefault(); selectRow(row)"
                  (keydown.enter)="$event.preventDefault(); selectRow(row)">
            </span>
          </td>
          <td>{{ row.name }}</td>
          <td>{{ row.portfolio?.name || 'Unassigned' }}</td>
          <td>{{ row.externalId || '-' }}</td>
          <td>{{ row.sicCode || '-' }}</td>
          <td>{{ row.region || '-' }}</td>
          <td class="text-end">{{ row.createdDate | date:'MM/dd/yy' }}</td>
        </tr>
        <tr *ngIf="!searchInProgress && noResultsMessageIsVisible" class="tts-empty-row">
          <td colspan="7" class="tts-empty py-4">
            <app-table-empty-state
              [emptyStateIcon]="emptyStateIcon"
              [headerText]="emptyStateHeader"
              [helpText]="emptyStateHelp"
            >
              <ng-container *ngIf="customerSupportUrl; else contactSupportEmailTemplate">
                <p>If you think this is an error,
                  <a class="support-link" target="_blank" rel="noopener noreferrer" [href]="customerSupportUrl">
                    Contact Support
                  </a>
                </p>
              </ng-container>
              <ng-template #contactSupportEmailTemplate>
                <ng-container *ngIf="contactSupportEmail; else defaultContactSupportMessage">
                  <p>If you think this is an error, please contact
                    <button class="btn btn-link ps-0 pt-0 pb-1" (click)="openSupportEmail()">
                      {{ contactSupportEmail }}
                    </button>
                  </p>
                </ng-container>
              </ng-template>
              <ng-template #defaultContactSupportMessage>
                <p>If you think this is an error, please contact your administrator.</p>
              </ng-template>
            </app-table-empty-state>
          </td>
        </tr>
        <tr *ngIf="searchInProgress && searchResults.length === 0" class="tts-empty-row">
          <td colspan="7" class="tts-empty text-muted text-center py-4">Searching…</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="tts-error-row d-flex justify-content-between align-items-center mt-2"
       *ngIf="error">
    <span class="tts-error-message">{{ error.copy }}</span>
    <a *ngIf="error.viewBorrowerUuid"
       class="tts-view-borrower-link"
       [href]="'/companies/' + error.viewBorrowerUuid"
       target="_blank"
       rel="noopener noreferrer">
      View Borrower <i class="fa-solid fa-arrow-right ms-1"></i>
    </a>
  </div>

  <div class="tts-pager-row d-flex justify-content-center mt-4 mb-3" *ngIf="total > limit">
    <pagination-template #p="paginationApi" [id]="pagerId" (pageChange)="changePage($event)">
      <nav aria-label="Target borrower pagination">
        <ul class="pagination tts-pagination mb-0">
          <li class="page-item" [ngClass]="{'disabled': p.isFirstPage()}">
            <a class="page-link" (click)="!p.isFirstPage() && p.previous()" aria-label="Previous">
              <span aria-hidden="true">&laquo;</span>
            </a>
          </li>
          <li class="page-item" *ngFor="let pg of p.pages" [ngClass]="{'active': p.getCurrent() === pg.value}">
            <a class="page-link" (click)="p.setCurrent(pg.value)" *ngIf="p.getCurrent() !== pg.value">{{ pg.label }}</a>
            <span class="page-link" *ngIf="p.getCurrent() === pg.value">{{ pg.label }}</span>
          </li>
          <li class="page-item" [ngClass]="{'disabled': p.isLastPage()}">
            <a class="page-link" (click)="!p.isLastPage() && p.next()" aria-label="Next">
              <span aria-hidden="true">&raquo;</span>
            </a>
          </li>
        </ul>
      </nav>
    </pagination-template>
  </div>
</div>
